import { Plug } from "lucide-react";
import { GrowwConnectForm } from "./GrowwConnectModal";

export const ConnectCard = ({ status, error, onConnect, onConnectTotp }) => {
  const expired = status.token_state === "expired";
  return <section className="stock connect-card" data-testid="connect-groww-card">
    <svg className="connect-bg" viewBox="0 0 600 200" aria-hidden="true">{Array.from({ length: 30 }, (_, i) => { const h = 20 + ((i * 37) % 70), y = 60 + ((i * 53) % 80); return <g key={i}><line x1={i * 20 + 10} x2={i * 20 + 10} y1={y - 10} y2={y + h + 10} /><rect x={i * 20 + 4} y={y} width="12" height={h} rx="2" /></g>; })}</svg>
    <div className="connect-inner">
      <div className="connect-icon"><Plug size={22} /></div>
      <h2 data-testid="connect-groww-title">{expired ? "Groww token expired — reconnect to see live prices" : "Connect Groww to see live prices"}</h2>
      <p>Real NSE prices, candles and BUY/SELL signals stream from your Groww account. No simulated data is shown.</p>
      {(error || status.token_error) && <div className="feed-error" data-testid="connect-groww-error">{error || status.token_error}</div>}
      {status.auth_mode === "TOTP" && expired ? <p className="muted">Use "Retry refresh" in the red banner above, or disconnect from the Groww button and connect again.</p>
        : <GrowwConnectForm tid="connect-card" onConnect={onConnect} onConnectTotp={onConnectTotp} />}
    </div>
  </section>;
};
